import React from 'react'
import { useTranslation } from 'react-i18next'
import { Span } from '@pandiafi/design-system'

import { BulletinType } from '../../../../../common/validations'

import { formatDateToString } from 'components/Bulletin/utils/formatDateToString'

interface BulletinDetailsProps {
  publishedAt: BulletinType['publishedAt']
  author: BulletinType['author']
  updatedAt: BulletinType['updatedAt']
}

export const BulletinDetails: React.FC<BulletinDetailsProps> = ({
  publishedAt,
  author,
  updatedAt,
}) => {
  const [t] = useTranslation(['bulletins'])

  return (
    <Span small light className="mb-4">
      {formatDateToString(publishedAt, true)}
      {author !== null && ` ${author}`}
      {updatedAt && ` (${t('edited')}: ${formatDateToString(updatedAt, true)})`}
    </Span>
  )
}
